import React, { FC, ReactNode } from 'react';
import styles from './Snack.module.scss';
import { useDispatch } from 'react-redux';
import { hideSnack } from 'Snackbar/ActionCreator';
import { CloseButtonImage } from 'static/images';

interface SnackProps {
  children: ReactNode;
  snackId: string;
  title: string;
}

const Snack: FC<SnackProps> = ({ children, snackId, title }) => {
  const dispatch = useDispatch();

  const handleHideSnack = () => {
    dispatch(hideSnack(snackId));
  };

  return (
    <div className={styles.snackContainer}>
      <div className={styles.snackHeader}>
        <div>{title}</div>
        <button type="button" onClick={handleHideSnack} className={styles.closeButton}>
          <CloseButtonImage />
        </button>
      </div>
      <div className={styles.snackBody}>{children}</div>
    </div>
  );
};

export default Snack;
